// extracted by mini-css-extract-plugin
export default {"autoLoginSection":"AutoLoginBlock_autoLoginSection","autoLoginSectionText":"AutoLoginBlock_autoLoginSectionText"};